import { gql } from '@apollo/client';
export const getKpiMetrics = gql`
    query getCurrentGoalValues($filters: JSONString!, $timePeriod: JSONString!, $dataSourceType: String!) {
        getCurrentGoalValues(filters: $filters, timePeriod: $timePeriod, dataSourceType: $dataSourceType) {
            kpiName
            kpiValue
        }
    }
`;

export const getScenarioNames = gql`
    query getScenarioNames {
        getScenarioNames
    }
`;

export const getAllScenarios = gql`
    query getScenariosList($limit: Int!, $offset: Int!) {
        getScenariosList(limit: $limit, offset: $offset) {
            scenarioId
            dataSourceType
            scenarioName
            userName
            modifiedOn
            kpis {
                kpiName
                kpiValue
            }
        }
    }
`;

export const getSimulatorInput = gql`
    query getCurrentPrices(
        $filters: JSONString!
        $timePeriod: JSONString!
        $attributeNames: [SamyaString]!
        $limit: Int!
        $offset: Int!
        $portfolioUpdateData: [JSONString]!
        $dataSourceType: String!
    ) {
        getCurrentPrices(
            filters: $filters
            timePeriod: $timePeriod
            attributeNames: $attributeNames
            limit: $limit
            offset: $offset
            portfolioUpdateData: $portfolioUpdateData
            dataSourceType: $dataSourceType
        ) {
            count
            pricesData
        }
    }
`;

export const getSimulatorOutput = gql`
    query getSimulatorOutputValues(
        $filters: JSONString!
        $timePeriod: JSONString!
        $attributeNames: [SamyaString]!
        $inputData: [JSONString]!
        $effectiveTimestamp: Int!
        $portfolioUpdateData: [JSONString]!
        $dataSourceType: String!
    ) {
        getSimulatorOutputValues(
            filters: $filters
            timePeriod: $timePeriod
            attributeNames: $attributeNames
            inputData: $inputData
            effectiveTimestamp: $effectiveTimestamp
            portfolioUpdateData: $portfolioUpdateData
            dataSourceType: $dataSourceType
        ) {
            count
            totalKpisData {
                kpiName
                kpiValue
            }
            metricsData
        }
    }
`;

export const saveScenario = gql`
    mutation updateScenario(
        $attributeNames: [SamyaString]!
        $filters: JSONString!
        $presetFilterJson: JSONString!
        $goalInputs: [JSONString]!
        $scenarioId: Int!
        $scenarioName: SamyaString!
        $simulatorInputs: [JSONString]!
        $timePeriod: JSONString!
        $userName: String!
        $globalFilter: [JSONString]!
        $effectiveTimestamp: Int!
        $portfolioUpdateData: [JSONString]!
        $dataSourceType: String!
    ) {
        updateScenario(
            attributeNames: $attributeNames
            filters: $filters
            presetFilterJson: $presetFilterJson
            goalInputs: $goalInputs
            scenarioId: $scenarioId
            scenarioName: $scenarioName
            simulatorInputs: $simulatorInputs
            timePeriod: $timePeriod
            userName: $userName
            globalFilter: $globalFilter
            effectiveTimestamp: $effectiveTimestamp
            portfolioUpdateData: $portfolioUpdateData
            dataSourceType: $dataSourceType
        ) {
            operationStatus
            scenarioId
        }
    }
`;

export const getScenario = gql`
    query getScenarioCompleteData($scenarioId: Int!) {
        getScenarioCompleteData(scenarioId: $scenarioId) {
            userName
            scenarioId
            dataSourceType
            startDate
            endDate
            priceEffectiveDate
            portfolioUpdateData
            recommendationOutput
            scenarioName
            globalFilter
            simulatorKpis
            goalInputs
            simulatorInputs
            simulatorOutput
            presetFilterJson
        }
    }
`;

export const getSimulatorRecommendationData = gql`
    query getSimulatorRecommendationData(
        $filters: JSONString!
        $timePeriod: JSONString!
        $attributeNames: [SamyaString]!
        $dataSourceType: String!
    ) {
        getSimulatorRecommendationData(
            filters: $filters
            timePeriod: $timePeriod
            attributeNames: $attributeNames
            dataSourceType: $dataSourceType
        ) {
            count
            recommendationData
        }
    }
`;

export const getQuartersMetricsData = gql`
    query getQuartersMetricsData($filters: JSONString!, $timePeriod: JSONString!, $dataSourceType: String!) {
        getQuartersMetricsData(filters: $filters, timePeriod: $timePeriod, dataSourceType: $dataSourceType) {
            quarter
            volume
            revenue
            profit
            tradeRatePercent
            retailerMargin
        }
    }
`;

export const deleteEvent = gql`
    mutation deleteScenario($scenarioId: Int!) {
        deleteScenario(scenarioId: $scenarioId) {
            operationStatus
        }
    }
`;

export const copyEvent = gql`
    mutation copyScenario($scenarioId: Int!, $scenarioName: SamyaString!, $userId: String!) {
        copyScenario(scenarioId: $scenarioId, scenarioName: $scenarioName, userId: $userId) {
            operationStatus
            scenarioId
        }
    }
`;

export const getPortfolioUpdateKpis = gql`
    query getPortfolioUpdateKpis(
        $rowAttributeName: SamyaString!
        $colAttributeName: SamyaString!
        $filters: JSONString!
        $timePeriod: JSONString!
        $dataSourceType: String!
    ) {
        getPortfolioUpdateKpis(
            rowAttributeName: $rowAttributeName
            colAttributeName: $colAttributeName
            filters: $filters
            timePeriod: $timePeriod
            dataSourceType: $dataSourceType
        ) {
            portfolioUpdateJsonData
        }
    }
`;

export const getPortfolioRecommndationMetrics = gql`
    query getPortfolioRecommendationMetrics(
        $rowAttributeName: SamyaString!
        $colAttributeName: SamyaString!
        $filters: JSONString!
        $timePeriod: JSONString!
        $selectedRow: SamyaString!
        $selectedColumn: SamyaString!
        $dataSourceType: String!
    ) {
        getPortfolioRecommendationMetrics(
            rowAttributeName: $rowAttributeName
            colAttributeName: $colAttributeName
            selectedRow: $selectedRow
            selectedColumn: $selectedColumn
            filters: $filters
            timePeriod: $timePeriod
            dataSourceType: $dataSourceType
        ) {
            kpiName
            kpiValue
        }
    }
`;

export const getPortfolioMetricsForinput = gql`
    query getPortfolioMetricsForInput($inputList: [JSONString]!) {
        getPortfolioMetricsForInput(inputList: $inputList) {
            kpiName
            kpiValue
        }
    }
`;
export const getPortfolioUpdateChangesAppliedKpis = gql`
    query getPortfolioUpdateChangesAppliedKpis(
        $rowAttributeName: SamyaString!
        $colAttributeName: SamyaString!
        $filters: JSONString!
        $timePeriod: JSONString!
        $portfolioUpdateData: [JSONString]!
        $dataSourceType: String!
    ) {
        getPortfolioUpdateChangesAppliedKpis(
            rowAttributeName: $rowAttributeName
            colAttributeName: $colAttributeName
            filters: $filters
            timePeriod: $timePeriod
            portfolioUpdateData: $portfolioUpdateData
            dataSourceType: $dataSourceType
        ) {
            totalKpisData {
                kpiName
                kpiValue
            }
            portfolioUpdateData
        }
    }
`;
